import cx from 'classix';
import {
  type ChangeEvent,
  type FocusEvent,
  type ReactNode,
} from 'react';

import styles from './toggle.module.scss';

interface ToggleProps {
  id: string;
  type: 'checkbox' | 'switch' | 'radio';
  children?: ReactNode;
  variant?: 'standard' | 'button';
  labelPosition?: 'left' | 'right';
  value?: string;
  name?: string;
  checked?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
}

export default function Toggle(props: ToggleProps) {
  const {
    checked,
    children,
    defaultChecked,
    disabled,
    id,
    labelPosition = 'right',
    name,
    onBlur,
    onChange,
    type,
    value,
    variant = 'standard',
  } = props;

  return (
    <>
      {variant === 'standard' && (
        <label className={cx(styles.toggleInput, labelPosition === 'left' && styles.toggleInput__left)} htmlFor={id}>
          <input
            defaultChecked={defaultChecked}
            checked={checked}
            className={cx(styles[type === 'switch' ? 'checkbox' : type], type === 'switch' && styles.switch)}
            disabled={disabled}
            id={id}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            type={type === 'switch' ? 'checkbox' : type}
            value={value}
            autoComplete="off"
          />
          <span className={styles.toggleInput_child}>{children}</span>
        </label>
      )}

      {variant === 'button' && (
        <div>
          <input
            defaultChecked={defaultChecked}
            checked={checked}
            className={styles.checkboxButton_input}
            disabled={disabled}
            id={id}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            type="checkbox"
            value={value}
            autoComplete="off"
          />
          <label className={styles.checkboxButton_label} htmlFor={id}>{children}</label>
        </div>
      )}
    </>
  );
}
